module.exports = __webpack_public_path__ + "static/Arboretum-Spring-800x500-58a5f78c2b67166f97b554084b8ef2a5.jpg";